<template>
    <v-card>
        <v-container>
            <form>
                <v-layout row wrap pt-4>
                    <v-flex xs12 px-5>
                        <v-text-field
                            v-model="email"
                            label="Email"
                            :counter="50"
                            :error-messages="errors.collect('Email')"
                            v-validate="'required|email'"
                            data-vv-name="Email"
                            class="requires--text"
                            data-cy="txtEmail"
                        ></v-text-field>
                    </v-flex>
                    <br />
                    <v-flex xs12 px-5>
                        <v-text-field
                            v-model="firstName"
                            label="First Name"
                            :counter="50"
                            :error-messages="errors.collect('firstName')"
                            v-validate="'required|alpha_spaces|max:50'"
                            data-vv-name="firstName"
                            class="requires--text"
                            data-cy="txtFirstName"
                        ></v-text-field>
                    </v-flex>
                    <br />
                    <v-flex xs12 px-5>
                        <v-text-field
                            v-model="lastName"
                            label="Last Name"
                            :counter="50"
                            :error-messages="errors.collect('lastName')"
                            v-validate="'required|alpha_spaces|max:50'"
                            data-vv-name="lastName"
                            class="requires--text"
                            data-cy="txtLastName"
                        ></v-text-field>
                    </v-flex>
                    <br />
                    <v-flex class="text-xs-center" px-5>
                        <v-btn
                            color="hubblue"
                            class="white--text"
                            @click="save"
                            :loading="loading"
                            :disabled="loading"
                            data-cy="btnSave"
                            >Save</v-btn
                        >
                    </v-flex>
                </v-layout>
            </form>
        </v-container>
    </v-card>
</template>

<script>
import axios from 'axios'
import { authHeader } from '../_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,

            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',

            email: null,
            firstName: null,
            lastName: null,
            profiles: []
        }
    },

    methods: {
        get() {
            axios
                .get(this.$store.state.userUrl + '/' + this.$store.state.authentication.loggedInUser.userId, {
                    headers: authHeader()
                })
                .then(response => {
                    if (response.data.userId !== undefined) {
                        this.email = response.data.email
                        this.firstName = response.data.firstName
                        this.lastName = response.data.lastName
                    } else {
                        let snackbarParams = {
                            message: response.data,
                            context: 'error'
                        }
                        this.$store.commit('showSnackbar', snackbarParams)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateUser() {
            this.loading = true
            const app = this
            let params = {
                email: app.email,
                firstName: app.firstName,
                lastName: app.lastName
            }
            let snackbarParams

            axios
                .patch(
                    this.$store.state.userUrl + '/' + this.$store.state.authentication.loggedInUser.userId,
                    {
                        params: params
                    },
                    { headers: authHeader() }
                )
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    this.$router.push({ name: 'Dashboard' })
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        save() {
            this.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        this.updateUser()
                    }
                })
                .catch(() => {
                    return false
                })
        }
    },
    created() {
        this.get()
    }
}
</script>
